<div class="digital-container">
  <app-product-intro-banner
    [eyebrow]="'digital.introBanner.eyebrow' | translate"
    [headline]="'digital.introBanner.headline' | translate"
    [description]="'digital.introBanner.description' | translate"
    [primaryCtaLabel]="'digital.introBanner.primaryCtaLabel' | translate"
    [secondaryCtaLabel]="'digital.introBanner.secondaryCtaLabel' | translate"
    [mediaImageSrc]="introBannerAssets.mediaImageSrc"
    [mediaImageAlt]="'digital.introBanner.mediaImageAlt' | translate"
    [videoSrc]="introBannerAssets.videoSrc"
    [videoTitle]="'digital.introBanner.videoTitle' | translate"
    [primaryCtaUrl]="digitalSignUpUrl"
  ></app-product-intro-banner>

  <app-product-how-it-works
    [headline]="productHowItWorksContent.headline"
    [tabs]="productHowItWorksContent.tabs"
  ></app-product-how-it-works>

  <app-product-program-benefits
    [headline]="productProgramBenefitsContent.headline"
    [description]="productProgramBenefitsContent.description"
    [descriptionLink]="productProgramBenefitsContent.descriptionLink"
    [stats]="productProgramBenefitsContent.stats"
    [cards]="productProgramBenefitsContent.cards"
  ></app-product-program-benefits>
</div>
